import {Component, Input, OnInit} from '@angular/core';
import { Network } from '@ionic-native/network/ngx';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input';
import { ApiService } from '../../services/api/api.service';
import { GlobalVariables } from '../../common/global-variables';

@Component({
  selector: 'app-product-payment',
  templateUrl: './product-payment.page.html',
  styleUrls: ['./product-payment.page.scss'],
})
export class ProductPaymentPage implements OnInit {

  @Input() product: any;

  dstvConfirmForm: FormGroup;
  dstvPaymentForm: FormGroup;
  dstvConfirmResponse: any;
  dstvPaymentResponse: any;
  dstvConfirmFormShow: boolean = true;
  dstvPaymentFormShow: boolean = false;
  showSuccessMessage: boolean = false;
  showErrorMessage: boolean = false;
  errorMessage: any;
  loaderToShow: any;

  constructor(private modalController: ModalController, public api: ApiService, public formBuilder: FormBuilder, public toastController: ToastController,  public globals: GlobalVariables, public loadingController: LoadingController, ) {
    this.dstvConfirmForm = this.formBuilder.group({
      smartCardNumber: ['', [Validators.required, Validators.min(1)]]
    });
    this.dstvPaymentForm = this.formBuilder.group({
      amount: ['', [Validators.required, Validators.min(1)]]
    });
   }

  ngOnInit() {
   
  }

  dstvConfirm() {
    this.showLoader('Loading...');
    const serviceURL = this.globals.userInfo.OmniServiceURL + 'dstvConfirm';

    const payload = {
        product: {
            ProductID: this.product.productID,
            ProductCode: this.product.productCode,
            Country: this.product.country,
            ProductName: this.product.productName,
            Supplier: this.product.supplier,
            Category: this.product.category,
            Provider: this.product.provider,
            PaymentType: this.product.paymentType,
            ServiceURL: this.product.serviceURL
        },
        smartcardNumber: this.dstvConfirmForm.value.smartCardNumber.toString(),
        operatorId: "Web",
        outletId: "6697-01"
    };

    this.api.postApiEndpoint(serviceURL, payload).subscribe((resp) => {
      if(resp.ok){
        this.hideLoader();
        this.dstvConfirmResponse = resp.data;
        this.dstvConfirmFormShow = false;
        this.dstvPaymentFormShow = true;
      } else {
        this.showErrorMessage = true;
        this.errorMessage = resp.msg;
      }
    },
    error => {
      this.hideLoader();
      this.presentToast("An error has occured", 'danger');
    });
  }

  dstvPayment() {
    this.showLoader('Loading...');
    const serviceURL = this.globals.userInfo.OmniServiceURL + 'dstvPayment';

    const payload = {
      product: {
          ProductID: this.product.productID,
          ProductCode: this.product.productCode,
          Country: this.product.country,
          ProductName: this.product.productName,
          Supplier: this.product.supplier,
          Category: this.product.category,
          Provider: this.product.provider,
          PaymentType: this.product.paymentType,
          ServiceURL: this.product.serviceURL
      },
      accountNumber: this.dstvConfirmResponse.smartCard,
      amount: this.dstvPaymentForm.value.amount.toString(),
      billPaymentRef: this.dstvConfirmResponse.lookupId
    };

    this.api.postApiEndpoint(serviceURL, payload).subscribe((resp) => {
      this.hideLoader();
      if(resp.ok){
        this.dstvPaymentResponse = resp.data;
        this.showSuccessMessage = true;
        this.dstvPaymentFormShow = false;
      } else {
        this.showErrorMessage = true;
        this.errorMessage = resp.msg;
      }
    },
    error => {
      this.hideLoader();
      this.presentToast("An error has occured", 'danger');
    });
  }

  async closeModal() {
    const onClosedData = {};
    await this.modalController.dismiss(onClosedData);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

  showLoader(displayMessage) {
    this.loaderToShow = this.loadingController.create({
      message: displayMessage
    }).then((res) => {
      res.present();

      res.onDidDismiss().then((dis) => {
      });
    });
  }

  hideLoader() {
    setTimeout(() => {
      this.loadingController.dismiss();
    }, 500);
  }
}